export default __webpack_public_path__ + "fonts/KFOlCnqEu92Fr1MmWUlfBBc4.woff2";